export class MatchBoard {
  constructor() {
    document.querySelectorAll('[data-match-filters]').forEach((form) => this.#bind(form))
  }

  #bind(form) {
    const list = form.parentElement?.querySelector('[data-match-list]')
    if (!list) return

    const items = [...list.querySelectorAll('[data-match-item]')]
    const season = form.querySelector('[data-match-filter="season"]')
    const phase = form.querySelector('[data-match-filter="phase"]')
    const sort = form.querySelector('[data-match-filter="sort"]')
    const reset = form.querySelector('[data-match-filter-reset]')

    let loaderTimer
    const apply = (withLoader = true) => {
      if (withLoader) {
        list.classList.add('is-loading')
        clearTimeout(loaderTimer)
      }
      const run = () => {
        const seasonValue = season?.value || ''
        const phaseValue = phase?.value || ''
        items.forEach((item) => {
          const seasonOk = seasonValue === '' || item.getAttribute('data-season') === seasonValue
          const phaseOk = phaseValue === '' || item.getAttribute('data-phase') === phaseValue
          item.hidden = !(seasonOk && phaseOk)
        })
        const visible = items.filter((item) => !item.hidden)
        visible.sort((a, b) => {
          const da = a.getAttribute('data-date') || ''
          const db = b.getAttribute('data-date') || ''
          return sort?.value === 'desc' ? db.localeCompare(da) : da.localeCompare(db)
        })
        visible.forEach((item) => list.append(item))
        list.classList.remove('is-loading')
      }
      if (withLoader) {
        loaderTimer = setTimeout(run, 280)
      } else {
        run()
      }
    }

    reset?.addEventListener('click', () => {
      if (season) season.value = ''
      if (phase) phase.value = ''
      if (sort) sort.value = 'asc'
      apply()
    })

    form.addEventListener('change', apply)
    apply(false)
  }
}
